<template>
	<div>
		<div @click="godetail(data)" class="item padding-tb-sm padding-lr-sm margin-bottom-sm flex flex-direction justify-between" :style="[{ width: width+'px',height:height+'px'}]">
			<p class="text-cut text-left" :style="[{ fontSize:size+'px'}]">{{data.title}}</p>
			<div class="flex justify-between align-start">
				<div class="flex align-center">
					<p class="tip-item text-333 round margin-right-19 text-sm">{{data.result == data?'招标公告':'中标结果'}}</p>
				</div>
				<div class="flex flex-direction justify-between align-center">
					<p class="text-price text-prices fu-fs34 text-bold">{{data.budget}}</p>
					<p class="text-999 text-xs">费用预算</p>
				</div>
			</div>
			<div class="flex align-center justify-between">
				<div class="flex align-center">
					<img class="block-63" :src="data.user.avatar" mode=""></img>
					<div class="flex flex-direction flex-sub justify-between margin-left-xs">
						<div class="text-333 text-sm text-cut text-left" style="width: 150px;">{{data.user.nick_name}}</div>
						<div class="flex align-center">
							<img v-if="data.user.is_real == 2" class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/authentication.png" mode=""></img>
							
							<img v-if="data.user.is_real_company == 2" class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/enterprise.png" mode=""></img>
							<img v-else class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/random.png" mode=""></img>
							<div class="text-999 text-sm">{{data.user.is_real_company == 2?'企业已认证':data.user.is_real == 2?'个人已认证':'未认证'}}</div>
						</div>
					</div>
				</div>
				<div class="flex align-center justify-end flex-sub margin-left-sm">
					<img class="add" src="https://manage.ciiply.com/web/static/home/work-add.png" mode=""></img>
					<span class="margin-left-8 text-cut">{{data.area}}</span>
				</div>
			</div>
			<div class="sticky text-center fu-fs26">置顶</div>
		</div>
	</div>
</template>

<script>
	export default {
	  props: {
	    width: {
	      type: [String,Number],
	      default:387
	    },
	    height:{
	    	type: [String,Number],
	    	default:168
	    },
		size:{//标题字体
			type: [String,Number],
			default:18
		},
		data:{
			type: Object,
			default:{}
		}
	  },
	  mounted(){
	    
	  },
	  methods: {
	    godetail(data){
			if(localStorage.getItem('user_token')){
				this.$router.push({
					name:'biddDetail',
					query: {
						id:data.id
					}
				})
			}else{
				Bus.$emit("showlogon")
			}
	    	
	    }
	  }
	};
</script>

<style scoped lang="less">
	.item{
		// width: 387px;
		// height: 168px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		position: relative;
		.block-63{
			width: 36px;
			height: 36px;
			border-radius: 50%;
		}
		.block-15{
			width: 15px;
			height: 15px;
		}
		.add{
			width: 16px;
			height: 19px;
		}
		.margin-left-8{
			margin-left: 8px;
		}
		.sticky{
			position: absolute;
			top: 0;
			right: 0;
			width: 45px;
			height: 24px;
			font-size: 13px;
			line-height: 24px;
			background: rgba(11, 131, 124, 0.1);
			border-radius: 0px 20px 0px 0px;
			color: #0B837C;
		}
		.tip-item{
			font-size: 13px;
			padding: 5px 10px;
			border-radius: 12px;
			background: #F1F1F1;
			margin-right: 9px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/list/bid-list.vue